export default __webpack_public_path__ + "static/media/login-left.06684a66.png";